import { ButtonTheme } from '../../types';

export const BUTTON_DEFAULT_THEME: ButtonTheme = {
    size: {
        xs: {
            height: 32,
            paddingX: 16,
            fontSize: 's',
            iconSize: 16,
            iconClearance: 6,
            radius: 3,
        },
        s: {
            height: 36,
            paddingX: 16,
            fontSize: 's',
            iconSize: 20,
            iconClearance: 8,
            radius: 4,
        },
        m: {
            height: 40,
            paddingX: 20,
            fontSize: 'm',
            iconSize: 20,
            iconClearance: 8,
            radius: 4,
        },
        l: {
            height: 48,
            paddingX: 20,
            fontSize: 'm',
            iconSize: 20,
            iconClearance: 8,
            radius: 5,
        },
        xl: {
            height: 54,
            paddingX: 20,
            fontSize: 'l',
            iconSize: 24,
            iconClearance: 10,
            radius: 6,
        },
        '2xl': {
            height: 64,
            paddingX: 20,
            fontSize: 'l',
            iconSize: 24,
            iconClearance: 10,
            radius: 8,
        },
    },
    fontWeight: 'bold',
    borderWidth: 2,
    colors: {
        primary: {
            background: 'primary.base',
            border: 'primary.base',
            textFilled: 'common.white',
            textOutlined: 'primary.base',
        },
        secondary: {
            background: 'secondary.base',
            border: 'secondary.base',
            textFilled: 'common.white',
            textOutlined: 'secondary.base',
        },
        callToAction: {
            background: 'accent.base',
            border: 'accent.base',
            textFilled: 'common.black',
            textOutlined: 'common.black',
        },
    },
    fixedColors: {
        neutral: {
            background: 'neutral.lightest',
            border: 'neutral.tint.200',
            textFilled: 'text.body',
            textOutlined: 'text.body',
        },
        white: {
            background: 'common.white',
            border: 'common.white',
            textFilled: 'text.body',
            textOutlined: 'common.white',
        },
    },
};
